import { graphql } from '@/gql';

export const DeleteGroupMutation = graphql(`
    mutation DeleteGroup($id: ObjectID!) {
        deleteGroup(id: $id) {
            __typename
            ... on DeleteGroupSuccessfulResponse {
                success
                deletedId
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);
